import axios from 'axios';

import { PetPlanReq, Plan } from '../../types/Plan/types';
import { apiRequest } from '../Utils/apiClient';
import { GET_PLANS, GET_PLANS_PORTAL } from '../Utils/constants';

export const GET_PLANS_BY_AGE = '/portaldb/solicitud/get_planes_mascota_for_fielpet';

const publicAxios = axios.create({
  baseURL: 'https://www.dawerbrokers.com',
  headers: {
    Accept: 'application/json',
  },
});

const getPlanes = async () => {
  return apiRequest<Plan[]>('get', GET_PLANS);
};

const getPlanesByEmail = async (email: string) => {
  return apiRequest<PetPlanReq[]>('get', GET_PLANS_PORTAL, { email });
};

/**
 * 🔓 Endpoint público (SIN Authorization)
 */
const getPreciosPlanesByEdadMascota = async (edadMascota: number): Promise<string[]> => {
  const res = await publicAxios.get<string[]>(GET_PLANS_BY_AGE, {
    params: { edad_mascota: edadMascota },
  });

  return res.data;
};

export { getPlanes, getPlanesByEmail, getPreciosPlanesByEdadMascota };
